const WizardLabel = ({ children, className = '' }) => {
  return <div className={`comp-wizard-label ${className}`}>{children}</div>;
};

export default WizardLabel;
